module.exports = __webpack_public_path__ + "img/shiyitu.42557f91.png";